import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import { useTranslation } from "../../hooks";
import { getPatientDisplayName } from "../../utils/appointmentFormat";
export function PatientPicker({ patients, scope, onChange, }) {
    const { t } = useTranslation("portal");
    if (patients.length <= 1)
        return null;
    return (_jsx(Box, { sx: { mb: 2, display: "flex", justifyContent: "flex-end" }, children: _jsxs(TextField, { select: true, size: "small", label: t("patientPickerLabel", "Showing"), value: String(scope), onChange: (event) => {
                const next = event.target.value;
                onChange(next === "ALL" ? "ALL" : Number(next));
            }, sx: {
                width: { xs: "100%", sm: 260 },
                "& .MuiOutlinedInput-root": { borderRadius: 999 },
            }, slotProps: {
                input: {
                    startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(FilterListRoundedIcon, { sx: { fontSize: 17, color: "text.secondary" } }) })),
                },
            }, children: [_jsx(MenuItem, { value: "ALL", children: t("allMembers", "All members") }), patients.map((patient) => {
                    const mrn = patient.mrn;
                    return (_jsxs(MenuItem, { value: String(patient.id), children: [getPatientDisplayName(undefined, {
                                firstName: patient.firstName ?? undefined,
                                lastName: patient.lastName ?? undefined,
                            }), mrn ? ` · ${t("mrn", "MRN {{mrn}}", { mrn })}` : ""] }, patient.id));
                })] }) }));
}
